<div id="layout" class="theme-cyan">
  <app-chat-leftmenu></app-chat-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Chat: Body -->
    <div class="chat-body">

      <!-- Chat: Header -->
      <div class="chat-header border-bottom py-xl-4 py-md-3 py-2">
        <div class="container-fluid">

          <div class="row align-items-center">

            <!-- Chat photo -->
            <div class="col-6 col-xl-4">
              <div class="media">
                <div class="avatar me-3">
                  <div class="avatar rounded-circle no-image bg-primary text-light">
                    <span><i class="zmdi zmdi-comment-text"></i></span>
                  </div>
                </div>
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h6 class="text-truncate mb-0 me-auto">Support ChatBot</h6>
                  </div>
                  <div class="text-truncate"><i class="zmdi zmdi-circle text-success"></i> Online</div>
                </div>
              </div>
            </div>

            <!-- Chat toolbar -->
            <div class="col-6 col-xl-8 text-end">

            </div>

          </div>

        </div>
      </div>

      <!-- Chat: Search -->
      <div class="collapse" id="chat-search-div">
        <div class="container-fluid py-2">

          <div class="input-group">
            <input type="text" class="form-control" placeholder="Find messages in current conversation">
            <div class="input-group-append">
              <span class="input-group-text text-muted">0 / 0</span>
            </div>
            <div class="input-group-append">
              <button type="button" class="btn btn-secondary">Search</button>
              <button type="button" class="btn btn-secondary dropdown-toggle dropdown-toggle-split"
                data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="sr-only">Toggle Dropdown</span>
              </button>
              <div class="dropdown-menu dropdown-menu-right shadow border-0">
                <a class="dropdown-item" href="javascript:void(0)">Action</a>
                <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                <div role="separator" class="dropdown-divider"></div>
                <a class="dropdown-item" href="javascript:void(0)">Separated link</a>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Chat: Content-->
      <div class="chat-content">
        <div class="container-fluid">

          <ul class="list-unstyled py-4">

            <!-- Message: Left -->
            <li class="d-flex message">

              <!-- Avatar -->
              <div class="mr-lg-3 me-2">
                <div class="avatar sm rounded-circle bg-primary d-flex align-items-center justify-content-center">
                  <span><i class="zmdi zmdi-comment-text text-light"></i></span>
                </div>
              </div>
              <!-- End Avatar -->

              <div class="message-body">
                <!-- Message: content -->
                <div class="message-row d-flex align-items-center">
                  <div class="message-content p-3">
                    🙌 Welcome back!<br>
                    How may I help you today? 🤖
                  </div>
                </div>
                <!-- Message: content -->
                <div class="message-row d-flex align-items-center">
                  <div class="message-content p-3">
                    👋 Hi​! I'm a Bot.<br> Let me know if you have any questions regarding our tool!
                  </div>
                </div>
                <!-- Message: content -->
                <div class="message-row d-flex align-items-center">
                  <div class="message-content p-3">
                    Select the topic or write your question below.
                  </div>
                </div>
                <!-- Message: content -->
                <div class="message-row d-flex align-items-center">
                  <button type="button" class="btn btn-outline-primary btn-rounded mb-1 me-1">Services</button>
                  <button type="button" class="btn btn-outline-dark btn-rounded mb-1 me-1">Solutions</button>
                  <button type="button" class="btn btn-outline-warning btn-rounded mb-1 me-1">Book a call</button>
                  <button type="button" class="btn btn-outline-primary btn-rounded mb-1 me-1">Leave a message</button>
                </div>

              </div>

            </li>

            <!-- Message: Left -->
            <li class="d-flex message">

              <!-- Avatar -->
              <div class="mr-lg-3 me-2">
                <div class="avatar sm rounded-circle bg-primary d-flex align-items-center justify-content-center">
                  <span><i class="zmdi zmdi-comment-text text-light"></i></span>
                </div>
              </div>
              <!-- End Avatar -->

              <div class="message-body">
                <!-- Message: content -->
                <div class="message-row d-flex align-items-center">
                  <div class="card rounded-3">
                    <div class="card-body">
                      <h5 class="card-title">Try it yourself!</h5>
                      <p class="card-text">Try ChatBot for free for 14 days before you buy it. No credit card required!
                      </p>
                    </div>
                    <div class="card-body">
                      <a [routerLink]="['/sign-up']" href="javascript:void(0)" class="card-link">✨ Sign up now!</a>
                      <a [routerLink]="['/chat']" href="javascript:void(0)" class="card-link">👈 Go to menu</a>
                    </div>
                  </div>
                </div>
              </div>

            </li>

          </ul>

        </div>
      </div>

      <!-- Chat: Footer -->
      <div class="chat-footer border-top py-xl-4 py-lg-2 py-2">
        <div class="container-fluid">

          <div class="row">
            <div class="col-12">
              <div class="input-group align-items-center">

                <!-- message textarea -->
                <input type="text" class="form-control border-0 pl-0" placeholder="Type your message...">

                <!-- message right icon-->
                <div class="input-group-append d-none d-sm-block">
                  <span class="input-group-text border-0">
                    <button class="btn btn-sm btn-link text-muted" data-bs-toggle="tooltip" title="Refresh"
                      type="button"><i class="zmdi zmdi-refresh font-22"></i></button>
                  </span>
                </div>
                <div class="input-group-append">
                  <span class="input-group-text border-0">
                    <button class="btn btn-sm btn-link text-muted" data-bs-toggle="tooltip" title="Smaily"
                      type="button"><i class="zmdi zmdi-mood font-22"></i></button>
                  </span>
                </div>
                <div class="input-group-append">
                  <span class="input-group-text border-0">
                    <button class="btn btn-sm btn-link text-muted" data-bs-toggle="tooltip" title="Attachment"
                      type="button"><i class="zmdi zmdi-attachment font-22"></i></button>
                  </span>
                </div>

                <!-- message send btn-->
                <div class="input-group-append">
                  <span class="input-group-text border-0 pr-0">
                    <button type="submit" class="btn btn-primary">
                      <span class="d-none d-md-inline-block me-2">Send</span>
                      <i class="zmdi zmdi-mail-send"></i>
                    </button>
                  </span>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
    <!-- End chat body -->

    <!-- Chat: user details -->
    <div class="user-detail-sidebar py-xl-4 py-3 px-xl-4 px-3">
      <div class="d-flex flex-column">
        <div class="header border-bottom pb-4 d-flex justify-content-between">
          <div>
            <h6 class="mb-0 fw-bold">User Details</h6>
            <span class="text-muted">Update your profile details</span>
          </div>
          <div>
            <button class="btn btn-link text-muted close-chat-sidebar" type="button"><i
                class="zmdi zmdi-close"></i></button>
          </div>
        </div>

        <div class="body mt-4">
          <div class="d-flex justify-content-center">
            <div class="avatar xxl">
              <img class="avatar xxl rounded-circle" src="../assets/images/sm/avatar2.jpg" alt="avatar">
            </div>
          </div>
          <div class="text-center mt-3 mb-5">
            <h4>Jason Porter</h4>
            <span class="text-muted">michelle.green@gmail.com</span>
            <p>+14 123 456 789 - New york (USA)</p>
          </div>

          <!-- Chat: mutual friend list -->
          <ul class="chat-list">
            <li class="header d-flex justify-content-between ps-3 pe-3 mb-1">
              <span>mutual friend</span>
            </li>
            <li>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar1.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Michelle Green</h6>
                      </div>
                      <div class="text-truncate">+14 123 456 258</div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar2.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Jason Porter</h6>
                      </div>
                      <div class="text-truncate">+14 123 456 963</div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar3.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Elizabeth Martin</h6>
                      </div>
                      <div class="text-truncate">+14 123 456 753</div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
          </ul>

        </div>
      </div>
    </div>

    <!-- Chat: add new user to create a group chat -->
    <div class="addnew-user-sidebar py-xl-4 py-3 px-xl-4 px-3">
      <div class="d-flex flex-column">
        <div class="header border-bottom pb-4 d-flex justify-content-between">
          <div>
            <h6 class="mb-0 fw-bold">Add new member</h6>
            <span class="text-muted">Update your profile details</span>
          </div>
          <div>
            <button class="btn btn-link text-muted close-chat-sidebar" type="button"><i
                class="zmdi zmdi-close"></i></button>
          </div>
        </div>

        <div class="body mt-4">

          <!-- Chat: user search -->
          <div class="form-group input-group-lg search mb-3">
            <i class="zmdi zmdi-search"></i>
            <input type="text" class="form-control" placeholder="Search...">
          </div>

          <!-- Chat: user list -->
          <ul class="chat-list">
            <li class="header d-flex justify-content-between ps-3 pe-3 mb-1">
              <span>A</span>
              <div class="dropdown">
                <a class="btn btn-link px-1 py-0 border-0 text-muted dropdown-toggle" href="javascript:void(0)"
                  role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></a>
                <div class="dropdown-menu dropdown-menu-right">
                  <a class="dropdown-item" href="javascript:void(0)">Action</a>
                  <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                  <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                </div>
              </div>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar1.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Amelia Green</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 2 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar3.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Ava Green</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 1 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li class="header d-flex justify-content-between ps-3 pe-3 mb-1">
              <span>C</span>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar4.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Charlotte Green</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 6 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar5.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Chloe Green</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 3 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar6.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Charles Green</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 2 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li class="header d-flex justify-content-between ps-3 pe-3 mb-1">
              <span>D</span>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar4.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">David Green</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 6 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li class="header d-flex justify-content-between ps-3 pe-3 mb-1">
              <span>M</span>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar8.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Michael Green</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 6 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar8.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Mohammad</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 6 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li class="header d-flex justify-content-between ps-3 pe-3 mb-1">
              <span>T</span>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar9.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Tommy Green</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 6 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
          </ul>

        </div>
      </div>
    </div>

  </div>
  <!-- Main Body: Content -->
</div>
